export default "__VITE_ASSET__056a927c__"